import React from 'react';
import './FormStyles.css';

export default function TextArea({
  label,
  name,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  placeholder = '',
  rows = 4,
  maxLength = null,
  className = '',
}) {
  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        className={`form-textarea ${error ? 'error' : ''}`}
      />
      {maxLength && (
        <small className="form-help">
          {value?.length || 0} / {maxLength}
        </small>
      )}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}
